// import { Box, Button, Card, Container, Grid, Popover, Typography } from "@mui/material";
// import { Input, message } from "antd";
// import axios from "axios";
// import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
// import "chart.js/auto";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import React, { useCallback, useEffect, useState } from "react";
// import { Bar, Pie } from "react-chartjs-2";
// import { FaChevronDown } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import Logo1 from "../../images/BhugolGIS.svg";
// import CompensatoryIcon from "../../images/CompensatoryTrees.svg";
// import InSituIcon from "../../images/InSituTrees.svg";
// import { ReactComponent as DashboardIcon } from "../../images/MapIconDashboard.svg";
// import Logo2 from "../../images/MMRCLogo.svg";
// import TotalTreesIcon from "../../images/TotalTrees.svg";
// import TransplantIcon from "../../images/TransplantTrees.svg";
// import { ReactComponent as UserAccountIcon } from "../../images/UserAccountIcon.svg";
// import { BaseURL } from "../../Utils/baseURL";
// import UserAccount from "../Auth/UserAccount";
// import "./Dashboard.css";

// ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

// const Dashboard = () => {
//   const [statsData, setStatsData] = useState([]);
//   const [treeCountData, setTreeCountData] = useState({ labels: [], datasets: [] });
//   const [selectedLocations, setSelectedLocations] = useState(() => JSON.parse(sessionStorage.getItem("selectedLocations")) || []);
//   const [filteredStatsData, setFilteredStatsData] = useState([]);
//   const [filteredTreeCountData, setFilteredTreeCountData] = useState({ labels: [], datasets: [] });
//   const [selectAllLocation, setSelectAllLocation] = useState(false);
//   const [searchQueryLocation, setSearchQueryLocation] = useState("");
//   const [statsLoading, setStatsLoading] = useState(true);
//   const [barChartLoading, setBarChartLoading] = useState(true);
//   const [pieChartLoading, setPieChartLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [locations, setLocations] = useState([]);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [treeDistributionData, setTreeDistributionData] = useState({ datasets: [], labels: [] });
//   const [topN, setTopN] = useState(10);
//   const [topNPie, setTopNPie] = useState(10);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [user, setUser] = useState({});
//   const [isAccountOpen, setIsAccountOpen] = useState(false);
//   const [filteredLocations, setFilteredLocations] = useState(locations);
//   const navigate = useNavigate();
//   const token = sessionStorage.getItem("token");
//   const open = Boolean(anchorEl);

//   const BasicLoader = () => (
//     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", minHeight: "100px" }}>
//       <div style={{ width: "40px", height: "40px", border: "4px solid #f3f3f3", borderTop: "4px solid #069C67", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
//       <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
//     </div>
//   );

//   const ErrorDisplay = ({ error, retry }) => (
//     <div style={{ textAlign: "center", padding: "20px" }}>
//       <Typography color="error">Error: {error}</Typography>
//       <Button onClick={retry} variant="contained" color="primary" style={{ marginTop: "10px" }}>Retry</Button>
//     </div>
//   );

//   const handleLoginCheck = () => {
//     if (!token) {
//       message.warning("You need to log in to use the filters.");
//       return false;
//     }
//     return true;
//   };

//   useEffect(() => {
//     const token = sessionStorage.getItem("token");
//     if (token) {
//       setIsLoggedIn(true);
//       fetchUserData(token);
//     }
//   }, []);

//   const fetchUserData = async (token) => {
//     try {
//       const response = await fetch(`${BaseURL}/auth/users/details/`, {
//         method: "GET",
//         headers: { Authorization: `token ${token}`, "Content-Type": "multipart/form-data" },
//       });
//       if (response.ok) {
//         const responseData = await response.json();
//         setUser(responseData.data);
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     }
//   };

//   const handleLogout = () => {
//     setIsLoggedIn(false);
//     setUser(null);
//     sessionStorage.removeItem("token");
//     sessionStorage.removeItem("selectedLocations");
//     setIsAccountOpen(false);
//     navigate("/");
//   };

//   const toggleAccount = () => {
//     setIsAccountOpen((prev) => !prev);
//   };

//   const fetchBarChartData = async (top = 10) => {
//     setBarChartLoading(true);
//     try {
//       const params = { top, ...(selectedLocations.length > 0 && { station__sid: selectedLocations.join(",") }) };
//       const speciesResponse = await axios.get(`${BaseURL}/survey/tree-surveys/dashboard/trees-by-species/`, {
//         headers: { Accept: "application/json", Authorization: `token ${token}` },
//         params,
//       });
//       if (speciesResponse.data.status === "success") {
//         setTreeCountData({
//           labels: speciesResponse.data.data.map((species) => species.species),
//           datasets: [{ label: "No. of Trees", data: speciesResponse.data.data.map((species) => species.count), backgroundColor: "#069C67", barThickness: 15 }],
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching bar chart data:", error);
//       if (error.response?.status === 400) {
//         message.error("Invalid location selection. Please try a different location.");
//       } else {
//         setError(error.message || "Failed to fetch bar chart data");
//       }
//     } finally {
//       setBarChartLoading(false);
//     }
//   };

//   const fetchPieChartData = async (top = 10) => {
//     setPieChartLoading(true);
//     try {
//       const params = { top, ...(selectedLocations.length > 0 && { station__sid: selectedLocations.join(",") }) };
//       const locationResponse = await axios.get(`${BaseURL}/survey/tree-surveys/dashboard/trees-by-station/`, {
//         headers: { Accept: "application/json", Authorization: `token ${token}` },
//         params,
//       });
//       if (locationResponse.data.status === "success") {
//         setTreeDistributionData({
//           labels: locationResponse.data.data.map((location) => location.station),
//           datasets: [{ data: locationResponse.data.data.map((location) => location.count), backgroundColor: ["#457ACA", "#003F5C", "#2F4B7C", "#665191", "#A05195", "#D45087", "#F95D6A", "#FF7C43", "#FFA600", "#099CDB"] }],
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching pie chart data:", error);
//       if (error.response?.status === 400) {
//         message.error("Invalid location selection. Please try a different location.");
//       } else {
//         setError(error.message || "Failed to fetch pie chart data");
//       }
//     } finally {
//       setPieChartLoading(false);
//     }
//   };

//   const handleSelectAll = (event) => {
//     event.preventDefault();
//     setSelectAllLocation(!selectAllLocation);
//     if (!selectAllLocation) {
//       setSelectedLocations([]);
//       fetchData([]);
//     } else {
//       setFilteredLocations(locations);
//     }
//     handleClose();
//   };

//   const handleSelectLocation = (location) => {
//     setSelectedLocations((prev) => {
//       const newSelection = prev.includes(location.sid)
//         ? prev.filter((sid) => sid !== location.sid)
//         : [location.sid];
//       setSelectAllLocation(false);
//       fetchData(newSelection); // Only fetch stats and bar chart
//       fetchPieChartData(topNPie); // Fetch pie chart separately
//       sessionStorage.setItem("selectedLocations", JSON.stringify(newSelection));
//       return newSelection;
//     });
//     handleClose();
//   };

//   const handleSearchQueryChange = (e) => {
//     const query = e.target.value.toLowerCase();
//     setSearchQueryLocation(query);
//     setFilteredLocations(locations.filter((loc) => loc.name.toLowerCase().includes(query)));
//   };

//   const handleClick = (event) => {
//     event.preventDefault();
//     if (handleLoginCheck()) {
//       setAnchorEl(event.currentTarget);
//     }
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//     setSearchQueryLocation("");
//     setFilteredLocations(locations);
//   };

//   useEffect(() => {
//     setFilteredStatsData(statsData);
//     setFilteredTreeCountData(treeCountData);
//   }, [statsData, treeCountData]);

//   const processFetchedData = (overviewData, speciesData) => {
//     const { total_trees_surveyed, survey_types } = overviewData;
//     const processedStatsData = [
//       { label: "Total Trees", value: total_trees_surveyed, bgColor: "#DFEEFF", icon: TotalTreesIcon },
//       { label: "In Situ", value: survey_types.in_situ || 0, bgColor: "#E7F9E8", icon: InSituIcon },
//       { label: "Transplant", value: survey_types.transplant || 0, bgColor: "#FFE7F8", icon: TransplantIcon },
//       { label: "Compensatory", value: survey_types.compensatory || 0, bgColor: "#FFE9DC", icon: CompensatoryIcon },
//     ];
//     const processedTreeCountData = {
//       labels: speciesData.map((species) => species.species),
//       datasets: [{ label: "No. of Trees", data: speciesData.map((species) => species.count), backgroundColor: "#069C67", barThickness: 15 }],
//     };
//     return { statsData: processedStatsData, treeCountData: processedTreeCountData };
//   };

//   useEffect(() => {
//     const fetchStations = async () => {
//       try {
//         const response = await axios.get(`${BaseURL}/program/stations/`, {
//           headers: { Accept: "application/json", Authorization: `token ${token}` },
//         });
//         if (response.data.status === "success") {
//           setLocations(response.data.data);
//           setFilteredLocations(response.data.data);
//         }
//       } catch (error) {
//         console.error("Error fetching stations data:", error);
//       }
//     };
//     if (token) fetchStations();
//   }, [token]);

//   const fetchData = async (selectedLocations, top = 10) => {
//     setStatsLoading(true);
//     setBarChartLoading(true);
//     setError(null);
//     try {
//       const params = { ...(selectedLocations.length > 0 && { station__sid: selectedLocations.join(",") }), top };
//       const [overviewResponse, speciesResponse] = await Promise.all([
//         axios.get(`${BaseURL}/survey/tree-surveys/dashboard/overview/`, { headers: { Accept: "application/json", Authorization: `token ${token}` }, params }),
//         axios.get(`${BaseURL}/survey/tree-surveys/dashboard/trees-by-species/`, { headers: { Accept: "application/json", Authorization: `token ${token}` }, params }),
//       ]);
//       if (overviewResponse.data.status === "success" && speciesResponse.data.status === "success") {
//         const processedData = processFetchedData(overviewResponse.data.data, speciesResponse.data.data);
//         setStatsData(processedData.statsData);
//         setTreeCountData(processedData.treeCountData);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       if (error.response?.status === 400) {
//         message.error("Invalid location selection. Please try a different location.");
//       } else {
//         setError(error.message || "Failed to fetch data");
//       }
//     } finally {
//       setStatsLoading(false);
//       setBarChartLoading(false);
//     }
//   };

//   // Separate useEffect for initial data fetch and location changes
//   const fetchDataMemoized = useCallback(() => {
//     fetchData(selectedLocations, topN);
//   }, [selectedLocations, topN, token]);

//   // Separate useEffect for pie chart updates
//   const fetchPieChartMemoized = useCallback(() => {
//     fetchPieChartData(topNPie);
//   }, [selectedLocations, topNPie, token]);

//   useEffect(() => {
//     if (token) fetchDataMemoized();
//   }, [fetchDataMemoized]);

//   useEffect(() => {
//     if (token) fetchPieChartMemoized();
//   }, [fetchPieChartMemoized]);

//   useEffect(() => {
//     if (selectedLocations.length > 0 && !selectAllLocation) {
//       setTopN(10);
//       setTopNPie(10);
//     }
//   }, [selectedLocations, selectAllLocation]);

//   const showTopNDropdowns = selectedLocations.length === 0 || selectAllLocation;

//   if (!token) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//         <Typography>Please log in to view the dashboard.</Typography>
//       </Box>
//     );
//   }

//   return (
//     <>
//       <Container className="dashboard-container" disableGutters maxWidth={false}>
//         <Box className="header" display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//           <p className="dashboard-title">DASHBOARD</p>
//           <Box display="flex" alignItems="center" className="top-right-controls-dashboard">
//             <button onClick={() => navigate("/")} className="Dashboard-icon-btn" style={{ background: "transparent", cursor: "pointer", marginRight: "8px" }}>
//               <DashboardIcon style={{ width: "40px", height: "100px", marginBottom: "25px" }} />
//             </button>
//             {isLoggedIn && (
//               <div className="user-account-container" style={{ marginRight: "8px" }}>
//                 <button onClick={toggleAccount} className="user-icon-btn">
//                   <UserAccountIcon style={{ width: "40px", height: "40px", marginBottom: "15px", background: "#f6f6f6" }} />
//                 </button>
//                 {isAccountOpen && <UserAccount user={user} onLogout={handleLogout} onClose={() => setIsAccountOpen(false)} />}
//               </div>
//             )}
//             <Button
//               type="button"
//               onClick={handleClick}
//               style={{
//                 color: "black",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 width: "200px",
//                 height: "40px",
//                 backgroundColor: "#fff",
//                 border: "1px solid #ccc",
//                 borderRadius: "5px",
//                 fontFamily: "'Poppins-thin', sans-serif",
//                 overflow: "hidden", // Prevent text overflow
//                 textOverflow: "ellipsis", // Truncate with ellipsis
//                 whiteSpace: "nowrap", // Keep text on one line
//                 padding: "0 10px", // Consistent padding
//               }}
//             >
//               <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                 {selectedLocations.length > 0
//                   ? selectedLocations.map((sid) => locations.find((loc) => loc.sid === sid)?.name).filter(Boolean).join(", ") || "Select Location"
//                   : "Select Location"}
//               </span>
//               <FaChevronDown />
//             </Button>
//             <Popover
//               open={open}
//               anchorEl={anchorEl}
//               onClose={handleClose}
//               anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//               transformOrigin={{ vertical: "top", horizontal: "left" }}
//             >
//               <div style={{ padding: "10px", width: "200px" }}>
//                 <Input
//                   placeholder="Search Location"
//                   value={searchQueryLocation}
//                   onChange={handleSearchQueryChange}
//                   style={{ marginBottom: "10px", width: "100%" }}
//                 />
//                 <div style={{ maxHeight: "150px", overflowY: "auto" }}>
//                   <div
//                     onClick={handleSelectAll}
//                     style={{ padding: "5px", cursor: "pointer", borderBottom: "1px solid #ccc", fontWeight: selectAllLocation ? "bold" : "normal" }}
//                   >
//                     Select All
//                   </div>
//                   {filteredLocations.map((location) => (
//                     <div key={location.sid} onClick={() => handleSelectLocation(location)} style={{ padding: "5px", cursor: "pointer", borderBottom: "1px solid #ccc" }}>
//                       {location.name}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </Popover>
//           </Box>
//         </Box>

//         {error ? (
//           <ErrorDisplay error={error} retry={() => { fetchDataMemoized(); fetchPieChartMemoized(); }} />
//         ) : (
//           <>
//             <Box className="card-container" p={0} mb={1}>
//               <Typography variant="h6" className="section-title" style={{ marginTop: "10px", marginLeft: "10px", fontFamily: "Poppins-Semi, sans-serif" }}>
//                 Trees Geotagged
//               </Typography>
//               {statsLoading ? (
//                 <BasicLoader />
//               ) : filteredStatsData.length > 0 ? (
//                 <Grid container spacing={3} justifyContent="center">
//                   {filteredStatsData.map((stat, index) => (
//                     <Grid item xs={12} sm={6} md={3} key={index}>
//                       <Card className="stats-card" elevation={0} style={{ backgroundColor: stat.bgColor, borderRadius: "16px" }}>
//                         <Box display="flex" flexDirection="row" alignItems="center" py={3} px={2.5}>
//                           <img src={stat.icon} alt={stat.label} style={{ width: "40px", height: "40px" }} />
//                           <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "20px" }}>
//                             <p style={{ fontFamily: "Poppins-Semi, sans-serif", fontSize: "22px", marginBottom: "0px", paddingBottom: "0px" }}>{stat.value}</p>
//                             <p style={{ fontFamily: "Poppins-thin", fontSize: "16px", color: "#6C6C6C", margin: 0 }}>{stat.label}</p>
//                           </div>
//                         </Box>
//                       </Card>
//                     </Grid>
//                   ))}
//                 </Grid>
//               ) : (
//                 <Typography>No data available for the selected locations.</Typography>
//               )}
//             </Box>

//             <Box className="chart-container" display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2}>
//               <Card className="chart-card" style={{ flex: 1 }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                   <Typography variant="h6" style={{ fontFamily: "Poppins-Semi, sans-serif" }}>Trees Geotagged by Name</Typography>
//                   {showTopNDropdowns && (
//                     <select
//                       id="top-n-select"
//                       value={topN}
//                       onChange={(e) => {
//                         e.preventDefault();
//                         const newTop = parseInt(e.target.value, 10);
//                         setTopN(newTop);
//                         fetchBarChartData(newTop);
//                       }}
//                       style={{ padding: "5px", borderRadius: "5px" }}
//                     >
//                       <option value={5}>Top 5</option>
//                       <option value={10}>Top 10</option>
//                       <option value={20}>Top 20</option>
//                       <option value={50}>Top 50</option>
//                     </select>
//                   )}
//                 </Box>
//                 <div style={{ height: "350px", width: "100%", borderRadius: "16px" }}>
//                   {barChartLoading ? (
//                     <BasicLoader />
//                   ) : filteredTreeCountData.labels.length > 0 ? (
//                     <Bar
//                       data={filteredTreeCountData}
//                       options={{
//                         maintainAspectRatio: false,
//                         responsive: true,
//                         plugins: { legend: { display: true }, datalabels: { color: "white", font: { size: 12, family: "Poppins-Semi, sans-serif" }, anchor: "end", align: "top" } },
//                         scales: {
//                           x: { title: { display: true, text: "Tree Names", font: { size: 14, family: "Poppins-Semi, sans-serif" }, color: "#000" }, ticks: { font: { size: 12 } } },
//                           y: { title: { display: true, text: "Tree Count", font: { size: 14, family: "Poppins-Semi, sans-serif" }, color: "#000" }, ticks: { font: { size: 12 } } },
//                         },
//                       }}
//                     />
//                   ) : (
//                     <Typography>No data available for the selected locations.</Typography>
//                   )}
//                 </div>
//               </Card>

//               <Card className="pie-card" style={{ flex: 1, maxHeight: "700px", overflow: "auto", borderRadius: "8px", padding: "20px" }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                   <Typography variant="h6" style={{ fontFamily: "Poppins-Semi, sans-serif" }}>Trees Geotagged by Location</Typography>
//                   {showTopNDropdowns && (
//                     <select
//                       id="top-n-pie-select"
//                       value={topNPie}
//                       onChange={(e) => {
//                         const newTopPie = parseInt(e.target.value, 10);
//                         setTopNPie(newTopPie);
//                         fetchPieChartData(newTopPie); // Only fetch pie chart data
//                       }}
//                       style={{ padding: "5px", borderRadius: "5px" }}
//                     >
//                       <option value={5}>Top 5</option>
//                       <option value={10}>Top 10</option>
//                       <option value={15}>Top 15</option>
//                       <option value={20}>Top 20</option>
//                     </select>
//                   )}
//                 </Box>
//                 <div style={{ display: "flex", alignItems: "flex-start" }}>
//                   {pieChartLoading ? (
//                     <BasicLoader />
//                   ) : (
//                     <>
//                       <div style={{ width: "300px", height: "300px", flexShrink: 0 }}>
//                         <Pie
//                           data={treeDistributionData}
//                           options={{
//                             responsive: true,
//                             plugins: {
//                               legend: { display: false },
//                               datalabels: {
//                                 color: "#fff",
//                                 font: { size: 10 },
//                                 formatter: (value, context) => {
//                                   const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
//                                   const percentage = ((value / total) * 100).toFixed(1);
//                                   return `${value} (${percentage}%)`;
//                                 },
//                                 anchor: "end",
//                                 align: "start",
//                                 offset: 15,
//                               },
//                             },
//                           }}
//                         />
//                       </div>
//                       <div style={{
//                         display: "grid",
//                         gridTemplateColumns: treeDistributionData.labels.length > 10 ? "1fr 1fr" : "1fr",
//                         gap: "8px",
//                         maxHeight: "100%",
//                         overflowY: "auto",
//                         padding: "10px",
//                         justifyContent: "flex-start",
//                         textAlign: "left",
//                       }}>
//                         {treeDistributionData.labels.map((label, index) => {
//                           const color = treeDistributionData.datasets[0].backgroundColor[index % treeDistributionData.datasets[0].backgroundColor.length];
//                           return (
//                             <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", textAlign: "left" }}>
//                               <div style={{ width: "12px", height: "12px", backgroundColor: color, marginRight: "8px", borderRadius: "4px" }}></div>
//                               <span style={{ fontFamily: "Poppins-Semi, sans-serif", fontSize: "12px", whiteSpace: "nowrap" }}>{label}</span>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </Card>
//             </Box>
//           </>
//         )}
//       </Container>

//       <Box className="footer" display="flex" justifyContent="space-between" alignItems="center" p={2} mt={2} style={{ borderTop: "2px solid #e0e0e0", backgroundColor: "#f9f9f9" }}>
//         <p color="black" style={{ margin: 0 }}>Copyright © 2024 Geosurvey | All Rights Reserved</p>
//         <Box display="flex" alignItems="center">
//           <img src={Logo2} alt="Logo 2" style={{ width: "50px", height: "50px", marginRight: "20px" }} />
//           <img src={Logo1} alt="Logo 1" style={{ width: "180px", height: "auto", marginRight: "16px" }} />
//         </Box>
//       </Box>
//     </>
//   );
// };

// export default Dashboard;


import { Box, Button, Card, Container, Grid, Popover, Typography } from "@mui/material";
import { Input, message } from "antd";
import axios from "axios";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Bar, Pie } from "react-chartjs-2";
import { FaChevronDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Logo1 from "../../images/BhugolGIS.svg";
import CompensatoryIcon from "../../images/CompensatoryTrees.svg";
import InSituIcon from "../../images/InSituTrees.svg";
import { ReactComponent as DashboardIcon } from "../../images/MapIconDashboard.svg";
import Logo2 from "../../images/MMRCLogo.svg";
import TotalTreesIcon from "../../images/TotalTrees.svg";
import TransplantIcon from "../../images/TransplantTrees.svg";
import { ReactComponent as UserAccountIcon } from "../../images/UserAccountIcon.svg";
import { BaseURL } from "../../Utils/baseURL";
import UserAccount from "../Auth/UserAccount";
import "./Dashboard.css";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const Dashboard = () => {
  const [statsData, setStatsData] = useState([]);
  const [treeCountData, setTreeCountData] = useState({ labels: [], datasets: [] });
  const [selectedLocations, setSelectedLocations] = useState(() => {
    const saved = sessionStorage.getItem("selectedLocations");
    return saved ? JSON.parse(saved) : [];
  });
  const [selectAllLocation, setSelectAllLocation] = useState(false);
  const [searchQueryLocation, setSearchQueryLocation] = useState("");
  const [statsLoading, setStatsLoading] = useState(true);
  const [barChartLoading, setBarChartLoading] = useState(true);
  const [pieChartLoading, setPieChartLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locations, setLocations] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [treeDistributionData, setTreeDistributionData] = useState({ datasets: [], labels: [] });
  const [topN, setTopN] = useState(10);
  const [topNPie, setTopNPie] = useState(10);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState({});
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [filteredLocations, setFilteredLocations] = useState([]);
  
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const open = Boolean(anchorEl);
  
  // Refs for abort controllers
  const abortControllerRef = useRef(null);
  const barChartAbortRef = useRef(null);
  const pieChartAbortRef = useRef(null);

  const BasicLoader = () => (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", minHeight: "100px" }}>
      <div style={{ width: "40px", height: "40px", border: "4px solid #f3f3f3", borderTop: "4px solid #069C67", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
  );

  const ErrorDisplay = ({ error, retry }) => (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <Typography color="error">Error: {error}</Typography>
      <Button onClick={retry} variant="contained" color="primary" style={{ marginTop: "10px" }}>Retry</Button>
    </div>
  );

  const handleLoginCheck = () => {
    if (!token) {
      message.warning("You need to log in to use the filters.");
      return false;
    }
    return true;
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      fetchUserData(token);
    }
  }, []);

  const fetchUserData = async (token) => {
    try {
      const response = await fetch(`${BaseURL}/auth/users/details/`, {
        method: "GET",
        headers: { Authorization: `token ${token}`, "Content-Type": "multipart/form-data" },
      });
      if (response.ok) {
        const responseData = await response.json();
        setUser(responseData.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("selectedLocations");
    setIsAccountOpen(false);
    navigate("/");
  };

  const toggleAccount = () => {
    setIsAccountOpen((prev) => !prev);
  };

  const fetchBarChartData = async (top = 10, selectedLocs = selectedLocations) => {
    // Cancel previous request
    if (barChartAbortRef.current) {
      barChartAbortRef.current.abort();
    }
    barChartAbortRef.current = new AbortController();

    setBarChartLoading(true);
    try {
      const params = { top, ...(selectedLocs.length > 0 && { station__sid: selectedLocs.join(",") }) };
      const speciesResponse = await axios.get(`${BaseURL}/survey/tree-surveys/dashboard/trees-by-species/`, {
        headers: { Accept: "application/json", Authorization: `token ${token}` },
        params,
        signal: barChartAbortRef.current.signal,
      });
      if (speciesResponse.data.status === "success") {
        setTreeCountData({
          labels: speciesResponse.data.data.map((species) => species.species),
          datasets: [{ label: "No. of Trees", data: speciesResponse.data.data.map((species) => species.count), backgroundColor: "#069C67", barThickness: 15 }],
        });
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Bar chart request cancelled");
        return;
      }
      console.error("Error fetching bar chart data:", error);
      if (error.response?.status === 400) {
        message.error("Invalid location selection. Please try a different location.");
      } else {
        setError(error.message || "Failed to fetch bar chart data");
      }
    } finally {
      setBarChartLoading(false);
    }
  };

  const fetchPieChartData = async (top = 10, selectedLocs = selectedLocations) => {
    // Cancel previous request
    if (pieChartAbortRef.current) {
      pieChartAbortRef.current.abort();
    }
    pieChartAbortRef.current = new AbortController();

    setPieChartLoading(true);
    try {
      const params = { top, ...(selectedLocs.length > 0 && { station__sid: selectedLocs.join(",") }) };
      const locationResponse = await axios.get(`${BaseURL}/survey/tree-surveys/dashboard/trees-by-station/`, {
        headers: { Accept: "application/json", Authorization: `token ${token}` },
        params,
        signal: pieChartAbortRef.current.signal,
      });
      if (locationResponse.data.status === "success") {
        setTreeDistributionData({
          labels: locationResponse.data.data.map((location) => location.station),
          datasets: [{ data: locationResponse.data.data.map((location) => location.count), backgroundColor: ["#457ACA", "#003F5C", "#2F4B7C", "#665191", "#A05195", "#D45087", "#F95D6A", "#FF7C43", "#FFA600", "#099CDB"] }],
        });
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Pie chart request cancelled");
        return;
      }
      console.error("Error fetching pie chart data:", error);
      if (error.response?.status === 400) {
        message.error("Invalid location selection. Please try a different location.");
      } else {
        setError(error.message || "Failed to fetch pie chart data");
      }
    } finally {
      setPieChartLoading(false);
    }
  };

  const handleSelectAll = (event) => {
    event.preventDefault();
    const newSelectAll = !selectAllLocation;
    setSelectAllLocation(newSelectAll);
    
    if (newSelectAll) {
        setSelectedLocations([]);
          sessionStorage.setItem("selectedLocations", JSON.stringify([]));
          fetchData([], topN);
          fetchPieChartData(topNPie, []);
    } else {
      // Deselect all
      setSelectedLocations([]);
      sessionStorage.setItem("selectedLocations", JSON.stringify([]));
      fetchData([], topN);
      fetchPieChartData(topNPie, []);
    }
    handleClose();
  };

  const handleSelectLocation = (location) => {
    setSelectedLocations((prev) => {
      let newSelection;
      if (prev.includes(location.sid) && prev.length === 1) {
        // If clicking the same (only selected) location, deselect it
        newSelection = [];
      } else {
        // Replace with new selection (only one location at a time)
        newSelection = [location.sid];
      }
      
      // Update selectAllLocation
      setSelectAllLocation(false);
      
      // Persist to sessionStorage
      sessionStorage.setItem("selectedLocations", JSON.stringify(newSelection));
      
      // Fetch data with new selection
      fetchData(newSelection, topN);
      fetchPieChartData(topNPie, newSelection);
      
      return newSelection;
    });
    handleClose();
  };

  const handleSearchQueryChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQueryLocation(query);
    setFilteredLocations(locations.filter((loc) => loc.name.toLowerCase().includes(query)));
  };

  const handleClick = (event) => {
    event.preventDefault();
    if (handleLoginCheck()) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearchQueryLocation("");
    setFilteredLocations(locations);
  };

  const processFetchedData = (overviewData, speciesData) => {
    const { total_trees_surveyed, survey_types } = overviewData;
    const processedStatsData = [
      { label: "Total Trees", value: total_trees_surveyed, bgColor: "#DFEEFF", icon: TotalTreesIcon },
      { label: "In Situ", value: survey_types.in_situ || 0, bgColor: "#E7F9E8", icon: InSituIcon },
      { label: "Transplant", value: survey_types.transplant || 0, bgColor: "#FFE7F8", icon: TransplantIcon },
      { label: "Compensatory", value: survey_types.compensatory || 0, bgColor: "#FFE9DC", icon: CompensatoryIcon },
    ];
    return processedStatsData;
  };

  useEffect(() => {
    const fetchStations = async () => {
      try {
        const response = await axios.get(`${BaseURL}/program/stations/`, {
          headers: { Accept: "application/json", Authorization: `token ${token}` },
        });
        if (response.data.status === "success") {
          setLocations(response.data.data);
          setFilteredLocations(response.data.data);
          
          // Check if all locations are selected on mount
          const saved = sessionStorage.getItem("selectedLocations");
          if (saved) {
            const savedLocs = JSON.parse(saved);
            setSelectAllLocation(savedLocs.length === response.data.data.length);
          }
        }
      } catch (error) {
        console.error("Error fetching stations data:", error);
        message.error("Failed to fetch locations");
      }
    };
    if (token) fetchStations();
  }, [token]);

  const fetchData = async (selectedLocs, top = 10) => {
    // Cancel previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();

    setStatsLoading(true);
    setBarChartLoading(true);
    setError(null);
    
    try {
      const params = { ...(selectedLocs.length > 0 && { station__sid: selectedLocs.join(",") }), top };
      const [overviewResponse, speciesResponse] = await Promise.all([
        axios.get(`${BaseURL}/survey/tree-surveys/dashboard/overview/`, { 
          headers: { Accept: "application/json", Authorization: `token ${token}` }, 
          params,
          signal: abortControllerRef.current.signal,
        }),
        axios.get(`${BaseURL}/survey/tree-surveys/dashboard/trees-by-species/`, { 
          headers: { Accept: "application/json", Authorization: `token ${token}` }, 
          params,
          signal: abortControllerRef.current.signal,
        }),
      ]);
      
      if (overviewResponse.data.status === "success" && speciesResponse.data.status === "success") {
        const processedStatsData = processFetchedData(overviewResponse.data.data, speciesResponse.data.data);
        setStatsData(processedStatsData);
        setTreeCountData({
          labels: speciesResponse.data.data.map((species) => species.species),
          datasets: [{ label: "No. of Trees", data: speciesResponse.data.data.map((species) => species.count), backgroundColor: "#069C67", barThickness: 15 }],
        });
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request cancelled");
        return;
      }
      console.error("Error fetching data:", error);
      if (error.response?.status === 400) {
        message.error("Invalid location selection. Please try a different location.");
      } else if (error.response?.status === 401) {
        message.error("Session expired. Please log in again.");
        handleLogout();
      } else {
        setError(error.message || "Failed to fetch data");
      }
    } finally {
      setStatsLoading(false);
      setBarChartLoading(false);
    }
  };

  // Initial data fetch
  useEffect(() => {
    if (token) {
      fetchData(selectedLocations, topN);
      fetchPieChartData(topNPie, selectedLocations);
    }
    
    // Cleanup on unmount
    return () => {
      if (abortControllerRef.current) abortControllerRef.current.abort();
      if (barChartAbortRef.current) barChartAbortRef.current.abort();
      if (pieChartAbortRef.current) pieChartAbortRef.current.abort();
    };
  }, [token]);

  // Update data when topN changes (only when no specific location is selected)
  useEffect(() => {
    if (token && (selectedLocations.length === 0 || selectAllLocation)) {
      fetchBarChartData(topN, selectedLocations);
    }
  }, [topN]);

  // Update pie chart when topNPie changes (only when no specific location is selected)
  useEffect(() => {
    if (token && (selectedLocations.length === 0 || selectAllLocation)) {
      fetchPieChartData(topNPie, selectedLocations);
    }
  }, [topNPie]);

  const showTopNDropdowns = selectedLocations.length === 0 || selectAllLocation;

  const getSelectedLocationNames = () => {
    if (selectedLocations.length === 0) return "Select Location";
    if (selectAllLocation) return "All Locations";
    
    const names = selectedLocations
      .map((sid) => locations.find((loc) => loc.sid === sid)?.name)
      .filter(Boolean);
    
    if (names.length === 0) return "Select Location";
    if (names.length === 1) return names[0];
    if (names.length === 2) return names.join(", ");
    return `${names[0]}, ${names[1]} +${names.length - 2} more`;
  };

  if (!token) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Typography>Please log in to view the dashboard.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Container className="dashboard-container" disableGutters maxWidth={false}>
        <Box className="header" display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <p className="dashboard-title">DASHBOARD</p>
          <Box display="flex" alignItems="center" className="top-right-controls-dashboard">
            <button onClick={() => navigate("/")} className="Dashboard-icon-btn" style={{ background: "transparent", cursor: "pointer", marginRight: "8px" }}>
              <DashboardIcon style={{ width: "40px", height: "100px", marginBottom: "25px" }} />
            </button>
            {isLoggedIn && (
              <div className="user-account-container" style={{ marginRight: "8px" }}>
                <button onClick={toggleAccount} className="user-icon-btn">
                  <UserAccountIcon style={{ width: "40px", height: "40px", marginBottom: "15px", background: "#f6f6f6" }} />
                </button>
                {isAccountOpen && <UserAccount user={user} onLogout={handleLogout} onClose={() => setIsAccountOpen(false)} />}
              </div>
            )}
            <Button
              type="button"
              onClick={handleClick}
              style={{
                color: "black",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "200px",
                height: "40px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontFamily: "'Poppins-thin', sans-serif",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                padding: "0 10px",
              }}
            >
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {getSelectedLocationNames()}
              </span>
              <FaChevronDown />
            </Button>
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <div style={{ padding: "10px", width: "200px" }}>
                <Input
                  placeholder="Search Location"
                  value={searchQueryLocation}
                  onChange={handleSearchQueryChange}
                  style={{ marginBottom: "10px", width: "100%" }}
                />
                <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                  <div
                    onClick={handleSelectAll}
                    style={{ 
                      padding: "5px", 
                      cursor: "pointer", 
                      borderBottom: "1px solid #ccc", 
                      fontWeight: selectAllLocation ? "bold" : "normal",
                      backgroundColor: selectAllLocation ? "#f0f0f0" : "transparent"
                    }}
                  >
                    Select All
                  </div>
                  {filteredLocations.map((location) => (
                    <div 
                      key={location.sid} 
                      onClick={() => handleSelectLocation(location)} 
                      style={{ 
                        padding: "5px", 
                        cursor: "pointer", 
                        borderBottom: "1px solid #ccc",
                        backgroundColor: selectedLocations.includes(location.sid) ? "#f0f0f0" : "transparent",
                        fontWeight: selectedLocations.includes(location.sid) ? "bold" : "normal"
                      }}
                    >
                      {location.name}
                    </div>
                  ))}
                </div>
              </div>
            </Popover>
          </Box>
        </Box>

        {error ? (
          <ErrorDisplay error={error} retry={() => { 
            fetchData(selectedLocations, topN);
            fetchPieChartData(topNPie, selectedLocations);
          }} />
        ) : (
          <>
            <Box className="card-container" p={0} mb={1}>
              <Typography variant="h6" className="section-title" style={{ marginTop: "10px", marginLeft: "10px", fontFamily: "Poppins-Semi, sans-serif" }}>
                Trees Geotagged
              </Typography>
              {statsLoading ? (
                <BasicLoader />
              ) : statsData.length > 0 ? (
                <Grid container spacing={3} justifyContent="center">
                  {statsData.map((stat, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Card className="stats-card" elevation={0} style={{ backgroundColor: stat.bgColor, borderRadius: "16px" }}>
                        <Box display="flex" flexDirection="row" alignItems="center" py={3} px={2.5}>
                          <img src={stat.icon} alt={stat.label} style={{ width: "40px", height: "40px" }} />
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "20px" }}>
                            <p style={{ fontFamily: "Poppins-Semi, sans-serif", fontSize: "22px", marginBottom: "0px", paddingBottom: "0px" }}>{stat.value}</p>
                            <p style={{ fontFamily: "Poppins-thin", fontSize: "16px", color: "#6C6C6C", margin: 0 }}>{stat.label}</p>
                          </div>
                        </Box>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography>No data available for the selected locations.</Typography>
              )}
            </Box>

            <Box className="chart-container" display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2}>
              <Card className="chart-card" style={{ flex: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6" style={{ fontFamily: "Poppins-Semi, sans-serif" }}>Trees Geotagged by Name</Typography>
                  {showTopNDropdowns && (
                    <select
                      id="top-n-select"
                      value={topN}
                      onChange={(e) => {
                        e.preventDefault();
                        const newTop = parseInt(e.target.value, 10);
                        setTopN(newTop);
                      }}
                      style={{ padding: "5px", borderRadius: "5px" }}
                    >
                      <option value={5}>Top 5</option>
                      <option value={10}>Top 10</option>
                      <option value={20}>Top 20</option>
                      <option value={50}>Top 50</option>
                    </select>
                  )}
                </Box>
                <div style={{ height: "350px", width: "100%", borderRadius: "16px" }}>
                  {barChartLoading ? (
                    <BasicLoader />
                  ) : treeCountData.labels.length > 0 ? (
                    <Bar
                      data={treeCountData}
                      options={{
                        maintainAspectRatio: false,
                        responsive: true,
                        plugins: { legend: { display: true }, datalabels: { color: "white", font: { size: 12, family: "Poppins-Semi, sans-serif" }, anchor: "end", align: "top" } },
                        scales: {
                          x: { title: { display: true, text: "Tree Names", font: { size: 14, family: "Poppins-Semi, sans-serif" }, color: "#000" }, ticks: { font: { size: 12 } } },
                          y: { title: { display: true, text: "Tree Count", font: { size: 14, family: "Poppins-Semi, sans-serif" }, color: "#000" }, ticks: { font: { size: 12 } } },
                        },
                      }}
                    />
                  ) : (
                    <Typography>No data available for the selected locations.</Typography>
                  )}
                </div>
              </Card>

              <Card className="pie-card" style={{ flex: 1, maxHeight: "700px", overflow: "auto", borderRadius: "8px", padding: "20px" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6" style={{ fontFamily: "Poppins-Semi, sans-serif" }}>Trees Geotagged by Location</Typography>
                  {showTopNDropdowns && (
                    <select
                      id="top-n-pie-select"
                      value={topNPie}
                      onChange={(e) => {
                        const newTopPie = parseInt(e.target.value, 10);
                        setTopNPie(newTopPie);
                      }}
                      style={{ padding: "5px", borderRadius: "5px" }}
                    >
                      <option value={5}>Top 5</option>
                      <option value={10}>Top 10</option>
                      <option value={15}>Top 15</option>
                      <option value={20}>Top 20</option>
                    </select>
                  )}
                </Box>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  {pieChartLoading ? (
                    <BasicLoader />
                  ) : (
                    <>
                      <div style={{ width: "300px", height: "300px", flexShrink: 0 }}>
                        <Pie
                          data={treeDistributionData}
                          options={{
                            responsive: true,
                            plugins: {
                              legend: { display: false },
                              datalabels: {
                                color: "#fff",
                                font: { size: 10 },
                                formatter: (value, context) => {
                                  const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
                                  const percentage = ((value / total) * 100).toFixed(1);
                                  return `${value} (${percentage}%)`;
                                },
                                anchor: "end",
                                align: "start",
                                offset: 15,
                              },
                            },
                          }}
                        />
                      </div>
                      <div style={{
                        display: "grid",
                        gridTemplateColumns: treeDistributionData.labels.length > 10 ? "1fr 1fr" : "1fr",
                        gap: "8px",
                        maxHeight: "100%",
                        overflowY: "auto",
                        padding: "10px",
                        justifyContent: "flex-start",
                        textAlign: "left",
                      }}>
                        {treeDistributionData.labels.map((label, index) => {
                          const color = treeDistributionData.datasets[0].backgroundColor[index % treeDistributionData.datasets[0].backgroundColor.length];
                          return (
                            <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", textAlign: "left" }}>
                              <div style={{ width: "12px", height: "12px", backgroundColor: color, marginRight: "8px", borderRadius: "4px" }}></div>
                              <span style={{ fontFamily: "Poppins-Semi, sans-serif", fontSize: "12px", whiteSpace: "nowrap" }}>{label}</span>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </Card>
            </Box>
          </>
        )}
      </Container>

      <Box className="footer" display="flex" justifyContent="space-between" alignItems="center" p={2} mt={2} style={{ borderTop: "2px solid #e0e0e0", backgroundColor: "#f9f9f9" }}>
        <p color="black" style={{ margin: 0 }}>Copyright © 2024 Geosurvey | All Rights Reserved</p>
        <Box display="flex" alignItems="center">
          <img src={Logo2} alt="Logo 2" style={{ width: "50px", height: "50px", marginRight: "20px" }} />
          <img src={Logo1} alt="Logo 1" style={{ width: "180px", height: "auto", marginRight: "16px" }} />
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;